import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { GridFilterProps } from '../../filters';
import { DateWidget, DateWidgetStore, Identifiable } from '@custis/common';
import { TTableColumn } from '../../models';
import { FilterWrapper } from '../filter-popup';
import { Dayjs } from 'dayjs';

interface Props<TItem extends Identifiable, TFilter, TSorting> extends GridFilterProps<Dayjs | null> {
  column: TTableColumn<TItem, TFilter, TSorting>;
  store: DateWidgetStore;
}

export const DateColumnFilter = observer(
  <TItem extends Identifiable, TFilter, TSorting>({
    store,
    value,
    onReset,
    onConfirm,
    ...rest
  }: Props<TItem, TFilter, TSorting>) => {
    useEffect(() => {
      store.setValue(value ?? null);
    }, []);

    const onClear = () => {
      onReset();
      store.setValue(null);
    };

    const onFind = (v: Dayjs | null | undefined) => {
      setTimeout(() => {
        onConfirm(v ?? store.date);
      }, 100);
    };

    return (
      <FilterWrapper {...rest} onConfirm={onFind} onReset={onClear}>
        <DateWidget store={store} />
      </FilterWrapper>
    );
  },
);
